import discordIcon from '@assets/social-icons/discord-icon.png';
import instagramIcon from '@assets/social-icons/instagram-icon-social.png';
import twitterIcon from '@assets/social-icons/twitter-icon.png';
import threadsIcon from '@assets/social-icons/threads.png';
import { isTestMode, siteDescription } from '@util/const.js';
import './home.scss';
import { graphics } from '@data/graphics.js';
import { information } from '@data/information.js';
import { chatbots } from '@data/chatbots.js';
import { overlays } from '@data/overlays.jsx';
import CarouselCard from '@components/shared/cards/carousel.card.jsx';
import ChildIcon from '@svg/child/child-icon.jsx';

const socialUsername = isTestMode ? 'playlive' : 'stjudeplaylive';

export default function Home() {
  const products = [
    ...Object.values(overlays),
    ...Object.values(chatbots),
    ...Object.values(information),
    ...Object.values(graphics),
  ];

  const newUpdatedProducts = products.filter(
    (product) =>
      (product.isNew || product.isUpdated || product.isFeatured) && product.show
  );

  return (
    <>
      <div className="md:hero main justify-items-center w-full items-center main relative md:h-auto h-[120px]">
        <div className="absolute top-16 left-0 w-full h-full hidden md:flex! justify-center">
          <div className="flex flex-col text-center">
            <div className="flex justify-center h-36">
              <ChildIcon />
            </div>
            <h2
              className={
                !isTestMode
                  ? 'text-3xl mb-2 -mt-20 text-white font-bold'
                  : 'hidden'
              }
            >
              St. Jude
            </h2>
            <h1 className="text-5xl text-white font-extrabold">
              Play Live Tools
            </h1>
          </div>
        </div>
      </div>

      <div className="hero md:mx-2  mb-0 -mt-28 border-0">
        <CarouselCard
          items={newUpdatedProducts}
          className="md:min-w-96 max-w-[385px] md:max-w-screen-md border-0"
          onGrid={false}
        />
      </div>
      <div className="hero -mt-10 py-24">
        <div className="hero-content flex-col text-center">
          <p className="text-lg mt-5">{siteDescription}</p>
          <p className="prose mt-10">
            If you have any questions, feedback or comments you can reach out to
            us in our Discord community or on Twitter.
          </p>
          <div>
            <div className="not-prose grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 my-4 gap-2 md:gap-6">
              <a
                className="card border-2 border-base-content/5 card-compact transition-all! duration-300 shadow hover:shadow-lg hover:-translate-y-1"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.discord.gg/stjudeplaylive"
              >
                <figure className="md:px-12 md:pt-6 py-2 w-full aspect-[2/1] items-end overflow-visible">
                  <div
                    className="aspect-square w-3/4 h-3/4 object-contain bg-base-content/60"
                    style={`mask: url(${discordIcon}) no-repeat center; mask-size: contain;`}
                  />
                </figure>
                <div className="hidden md:card-body! text-center">
                  <span className="text-gray-500">
                    discord.gg/{socialUsername}
                  </span>
                </div>
              </a>

              <a
                className="card border-2 border-base-content/5 card-compact transition-all! duration-300 shadow hover:shadow-lg hover:-translate-y-1"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/stjudeplaylive/"
              >
                <figure className="md:px-12 md:pt-6 py-2 w-full aspect-[2/1] items-end overflow-visible">
                  <div
                    className="aspect-square w-3/4 h-3/4 object-contain bg-base-content/60"
                    style={`mask: url(${instagramIcon}) no-repeat center; mask-size: contain;`}
                  />
                </figure>
                <div className="hidden md:card-body! text-center">
                  <span className="text-gray-500">
                    instagram.com/{socialUsername}
                  </span>
                </div>
              </a>

              <a
                className="card border-2 border-base-content/5 card-compact transition-all! duration-300 shadow hover:shadow-lg hover:-translate-y-1"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.twitter.com/stjudeplaylive"
              >
                <figure className="md:px-12 md:pt-6 py-2 w-full aspect-[2/1] items-end overflow-visible">
                  <div
                    className="aspect-square w-3/4 h-3/4 object-contain bg-base-content/60"
                    style={`mask: url(${twitterIcon}) no-repeat center; mask-size: contain;`}
                  />
                </figure>
                <div className="hidden md:card-body! text-center">
                  <span className="text-gray-500">x.com/{socialUsername}</span>
                </div>
              </a>

              <a
                className="card border-2 border-base-content/5 card-compact transition-all! duration-300 shadow hover:shadow-lg hover:-translate-y-1"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.threads.net/stjudeplaylive"
              >
                <figure className="md:px-12 md:pt-6 py-2 w-full aspect-[2/1] items-end overflow-visible">
                  <img
                    className="aspect-square w-3/4 h-3/4 object-contain"
                    alt="Threads"
                    src={`${threadsIcon}`}
                  />
                </figure>
                <div className="hidden md:card-body! text-center">
                  <span className="text-gray-500">
                    threads.net/{socialUsername}
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
